import { scaleView, type ScaleInput } from './scaleRow'

/**
 * Шкала растрового слоя на карте: цвет — величина — края.
 *
 * Общая на «Карты» и «Аналитику». До 07.09.2026 её рисовали только «Карты»
 * (`maps/Legend`), и в «Аналитике» два раздела из трёх — течения и комфортная
 * среда — красили карту цветом, который нечем было прочитать; шкала была лишь у
 * апвеллинга, своим компонентом.
 *
 * Состав считает `scaleRow`, и его же печатает плашка скачанного кадра: пока
 * источник один, экран и файл разойтись не могут.
 */
export function ScalePanel({ scale }: { scale: ScaleInput | null }) {
  const v = scale && scaleView(scale)
  if (!v) return null
  return (
    <div className="pointer-events-auto min-w-[172px] rounded-xl border border-hull bg-abyss/90 px-3.5 py-3 shadow-console backdrop-blur">
      <div className="mb-2 flex items-baseline justify-between gap-3">
        <span className="text-xs font-semibold text-foam">{v.label}</span>
        {v.unit && <span className="tnum text-[11px] text-sonar">{v.unit}</span>}
      </div>
      <div
        className="h-2.5 rounded"
        style={{ background: v.gradient }}
      />
      <div
        className={`mt-1.5 flex justify-between text-[10px] ${
          v.numeric ? 'tnum text-foam' : 'text-mist'
        }`}
      >
        {v.ticks.map(tick => (
          <span key={tick}>{tick}</span>
        ))}
      </div>
    </div>
  )
}
